import { store } from "../_store";

export function authHeader() {
  // return authorization header with jwt token
  try {
    let userToken = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user")).token
      : store.getters["authentication/getJWT"];
    if (userToken) {
      return { Authorization: "JWT " + userToken };
    } else {
      return {};
    }
  } catch (error) {
    alert(error);
  }
}
